import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, PRIMARY_OUTLET, Router, UrlSegment, UrlSegmentGroup, UrlTree } from '@angular/router';
import { environment } from '../environments/environment';

import 'moment-timezone';
import { SplashScreenService } from './_shared/core/services/splash-screen.service';
import { MouseMoveService } from './_shared/core/services/mouse-move.service';
import { AuthService } from './account/core/services/auth.service';
import { GoogleMapsLoaderService } from './_shared/core/services/google-maps-loader.service';
import { BRANDING } from './_shared/core/constants/branding.constants';

declare const loadGoogleTagManager: any;
export let browserRefreshed = false;

@Component({
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  title = BRANDING.COMPANY_NAME;

  private unsubscribe: Subscription[] = [];

  constructor(
    private splashScreenService: SplashScreenService,
    private mouseMoveService: MouseMoveService,
    private router: Router,
    private readonly authService: AuthService,
    private readonly googleMapsLoader: GoogleMapsLoaderService,
  ) {
  }

  @HostListener('mousemove', ['$event']) onMousemove(event: MouseEvent) {
    this.mouseMoveService.mouseMoveEvent();
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent): void {
    if (!this.authService.isAuthenticated) {
      const tree: UrlTree = this.router.parseUrl(this.router.url);
      const segmentGroup: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
      const segment: UrlSegment[] = segmentGroup.segments;

      if (segment && segment.length > 0 && segment[0].path !== 'account') {
        this.router.navigate(['/account', 'login']);
      }
    }
  }

  ngOnInit() {
    const routerSubscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
      if (event instanceof NavigationStart) {
        browserRefreshed = !this.router.navigated;
      }
    });

    this.unsubscribe.push(routerSubscription);

    this.googleMapsLoader.loadGoogleMaps().then(() => {
      this.loadGoogleTagManager();
    });
  }

  loadGoogleTagManager() {
    if (environment.gtmContainerId) {
      loadGoogleTagManager(window, document, 'script', 'dataLayer', environment.gtmContainerId, environment.gtmAuthKey, environment.gtmEnvironment);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

}
